"use strict";
function memoize(fn) {
  var cache = {};
  return function(arg) {
    return void 0 === cache[arg] && (cache[arg] = fn(arg)), cache[arg];
  };
}
Object.defineProperty(exports, "__esModule", { value: !0 }),
  (exports.default = memoize);
